import CommonUiModel from "../common/commonUiModel";

const ManufactureModel = new CommonUiModel({
    title: "Manufacturer",
    columns: [
        { field: 'ManufacturerId', gridLabel: 'Manufacturer Id', type: 'number', width: 120, label: null },
        { field: 'ManufacturerName', label: 'Manufacturer', required: true, max: 100 },
        { field: "ManufacturerAlias", label: "Alias", type: "chipInput", required: false, lookup: 'ManufacturerAlias', width: 300, hasDefault: true, disabled: ({ isAdd }) => isAdd, dataFormat: "array" },
        { field: 'Notes', label: 'Notes', multiline: true, max: 2000 },
        { field: 'Active', label: 'Active', type: 'boolean', width: 80, defaultValue: true, sortable: false }
    ]
});

export default ManufactureModel;